
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportAcademicTable from '../Table';
import ReportAcademicRecyclingTable from '../RecyclingTable';
import ReportAcademicEnrollmentExpirationTable from '../EnrollmentExpirationTable';
import CustomTabComponent from '../../../../../components/CustomTab/index';
import {Grid} from '@material-ui/core'


import { useStyles } from './styles';

export default ({ fields }) => {
  const classes = useStyles();
    const [paginationNumber, setPaginationNumber] = React.useState(0);
    
   const { t } = useTranslation([
      'title',
      'form',
      'button',
      'validation',
      'toastify',
      'label',
    ]);

  const tabComponents = [
      {
        label: t('tables:reports.title_reports_academic'),
        component: <ReportAcademicTable required={false} fields={fields} />
      },
      {
        label: t('tables:reports.title_reports_required_academic'),
        component: <ReportAcademicTable required={true} fields={fields} />
      },
      {
        label: 'Relatório Reciclagens',
        component: <ReportAcademicRecyclingTable />
      },
      {
        label: 'Expiração de Matrículas',
        component: <ReportAcademicEnrollmentExpirationTable />
      },
    ];

  return (
    <div className={classes.root}>
      <div className={classes.topButtonContainer}>
        <Grid item xs={12}>
          <CustomTabComponent
            components={tabComponents}
            valueReturn={(value) => setPaginationNumber(value)}
          />
        </Grid>
      </div>
    </div>
    );
};

class TabValues {
  static Academic = 1;
  static RequiredAcademic = 0;
}
